import type { Action } from '@ngrx/store';
import type { UserCore } from '../../interfaces/User.interface';

export enum ActionType {
    FETCH_CURRENT_USER = '[PROFILE] FETCH_CURRENT_USER',
    FETCH_CURRENT_USER_SUCCEEDED = '[PROFILE] FETCH_CURRENT_USER_SUCCEEDED',
    FETCH_CURRENT_USER_FAILED = '[PROFILE] FETCH_CURRENT_USER_FAILED',

    SET_RIGHTS = '[PROFILE] SET_RIGHTS',

    UPDATE_CURRENT_USER = '[PROFILE] UPDATE_CURRENT_USER',

    SET_IS_PENDING = '[PROFILE] SET_IS_PENDING',
    RESET_RIGHTS = '[PROFILE] RESET_RIGHTS',
    RESET = '[PROFILE] RESET'
}

export class FetchCurrentUser implements Action {
    readonly type = ActionType.FETCH_CURRENT_USER;
}

export class FetchCurrentUserSucceeded implements Action {
    readonly type = ActionType.FETCH_CURRENT_USER_SUCCEEDED;
    constructor(readonly payload: { user: UserCore }) {}
}

export class FetchCurrentUserFailed implements Action {
    readonly type = ActionType.FETCH_CURRENT_USER_FAILED;
}

export class SetRights implements Action {
    readonly type = ActionType.SET_RIGHTS;
    constructor(readonly payload: { rights: string[] }) {}
}

export class UpdateCurrentUser implements Action {
    readonly type = ActionType.UPDATE_CURRENT_USER;
    constructor(readonly payload: { userUpdate: Partial<UserCore> }) {}
}

export class SetIsPending implements Action {
    readonly type = ActionType.SET_IS_PENDING;
    constructor(readonly payload: boolean) {}
}

export class ResetRights implements Action {
    readonly type = ActionType.RESET_RIGHTS;
}

export class Reset implements Action {
    readonly type = ActionType.RESET;
}

export type Actions =
    | FetchCurrentUser
    | FetchCurrentUserSucceeded
    | FetchCurrentUserFailed
    | SetRights
    | UpdateCurrentUser
    | SetIsPending
    | ResetRights
    | Reset;
